
// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ResetPassword from "layouts/authentication/reset-password";
import ResetNewPassword from "layouts/authentication/confirmResetPassword";
import PrivateRoute from "layouts/authentication/PrivateRoute";
import { FaUniversity } from "react-icons/fa";

// Soft UI Dashboard React icons
import Shop from "reusableComponents/Icons/Shop";
import Office from "reusableComponents/Icons/Office";
import Document from "reusableComponents/Icons/Document";
import SpaceShip from "reusableComponents/Icons/SpaceShip";
import CustomerSupport from "reusableComponents/Icons/CustomerSupport";
import Departments from "./mainComponents/departments/Departments";
import Universities from "./mainComponents/universities/Universities";
import Librarians from "./mainComponents/librarians/Librarians";
import { HiMiniUsers } from "react-icons/hi2";
import ResearcherManagement from "./mainComponents/researcherManagement/ResearcherManagement";
import confirmation from "./layouts/authentication/confirmation";
import Report from "./mainComponents/report/Report";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { BsFiletypeJson } from "react-icons/bs";
import SwaggerDoc from "swagger/swaggerDocs";
import DigitizationEditor from "./mainComponents/yai4eduEditor/DigitizationEditor";
import ErrorPages from "./reusableComponents/ErrorPages/ErrorPages";
import { MdMiscellaneousServices } from "react-icons/md";
import ServicesList from "./layouts/services/ServicesList";
import Publications from "./layouts/publications";
import {ALMANDUMA_CUSTOMER, PUBLICATIONS_VIEW, USER_PUBLICATIONS_VIEW} from "./utlis/constant";
import ManageBatches from "./mainComponents/batches/ManageBatches";
import BatchFilesPage from "./mainComponents/batches/BatchFilesPage";

const customerName = window?.appConfig?.REACT_APP_CUSTOMER_NAME || process.env.REACT_APP_CUSTOMER_NAME
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/:lang/dashboard",
    icon: <Shop size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['super-admin', 'librarian', 'researcher', 'library-admin']} component={Dashboard} />
    ),
    noCollapse: true,
  },
    customerName !== ALMANDUMA_CUSTOMER && {
    type: "collapse",
    name: "Departments List",
    key: "departments-list",
    route: "/:lang/departments-list",
    icon: <Office size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['library-admin']} component={Departments} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Universities List",
    key: "universities-list",
    route: "/:lang/universities-list",
    icon: <FaUniversity size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['super-admin']} component={Universities} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Librarian Admins Management",
    key: "librarian-admins",
    route: "/:lang/librarian-admins",
    icon: <Office size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['super-admin']} component={Librarians} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Librarian Management",
    key: "librarian-management",
    route: "/:lang/librarian-management",
    icon: <Office size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['library-admin']} component={Librarians} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "User Management",
    key: "user-management",
    route: "/:lang/user-management",
    icon: <Office size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['library-admin']} component={Librarians} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/:lang/profile",
    icon: <CustomerSupport size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['super-admin', 'librarian', 'library-admin', 'researcher']} component={Profile} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/:lang/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <PrivateRoute publicRoute={true} allowedRoles={["researcher"]} component={SignIn} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "admin-sign-in",
    route: "/:lang/admin/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <PrivateRoute publicRoute={true} allowedRoles={["admin"]} component={SignIn} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "librarian-sign-in",
    route: customerName === ALMANDUMA_CUSTOMER ? "/:lang/user/authentication/sign-in" : "/:lang/librarian/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <PrivateRoute publicRoute={true} allowedRoles={["librarian"]} component={SignIn} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "librarian-admin-sign-in",
    route: "/:lang/librarian-admin/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <PrivateRoute publicRoute={true} allowedRoles={["librarian-admin"]} component={SignIn} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    route: "/:lang/authentication/sign-up",
    icon: <SpaceShip size="12px" />,
    component: <PrivateRoute publicRoute={true} component={SignUp} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Reset Password Form",
    key: "reset-password-form",
    route: "/:lang/authentication/reset-password",
    icon: <SpaceShip size="12px" />,
    component: <PrivateRoute publicRoute={true} component={ResetPassword} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Confirm Reset Password",
    key: "confirm-reset-password",
    route: "/:lang/authentication/confirm-reset-password/:token",
    icon: <SpaceShip size="12px" />,
    component: <PrivateRoute publicRoute={true} component={ResetNewPassword} />,
    noCollapse: true,
  },
    customerName !== ALMANDUMA_CUSTOMER && {
    type: "collapse",
    name: "Researcher Management",
    key: "researcher-management",
    route: "/:lang/researcher-management",
    icon: <HiMiniUsers size="12px" />,
    component: (
        <PrivateRoute allowedRoles={['librarian']} component={ResearcherManagement} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    route: "/:lang/documents",
    component: <PrivateRoute allowedRoles={['super-admin', 'librarian', 'researcher', 'library-admin']} component={Publications} view={PUBLICATIONS_VIEW} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Confirmation",
    key: "confirmation",
    route: "/:lang/authentication/confirmation",
    component: <PrivateRoute publicRoute={true} component={confirmation} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Report",
    key: "report",
    route: "/:lang/report",
    component: <PrivateRoute allowedRoles={['super-admin','librarian', 'library-admin']} component={Report} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "My Documents",
    key: "my-documents",
    route: "/:lang/my-documents",
    icon: <Document size="12px" />,
    component: <PrivateRoute allowedRoles={['librarian', 'researcher']} component={Publications} view={USER_PUBLICATIONS_VIEW} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Document",
    key: "document",
    route: "/:lang/document",
    icon: <Document size="12px" />,
    component: <PrivateRoute allowedRoles={['super-admin', 'librarian', 'researcher', 'library-admin']} component={DigitizationEditor} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Services List",
    key: "services-list",
    route: "/:lang/services-list",
    icon: <MdMiscellaneousServices size="12px"/>,
    component: <PrivateRoute publicRoute={true} component={ServicesList} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Error",
    key: "error",
    route: "/:lang/error-page",
    icon: <FaFileInvoiceDollar size="12px"/>,
    component: <PrivateRoute publicRoute={true} component={ErrorPages} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Manage Batches",
    key: "manage-batches",
    route: "/:lang/manage-batches",
    icon: <BsFiletypeJson size="12px"/>,
    component: (
        <PrivateRoute allowedRoles={['super-admin', 'library-admin']} component={ManageBatches} />
    ),
    noCollapse: true,
  },{
    type: "collapse",
    name: "Batch",
    key: "batch",
    route: "/:lang/batch",
    icon: <Document size="12px" />,
    component: <PrivateRoute allowedRoles={['super-admin', 'library-admin']} component={BatchFilesPage} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "API Documentation",
    key: "api-docs",
    route: "/:lang/api-docs",
    icon: <BsFiletypeJson size="12px"/>,
    component: (
        <PrivateRoute allowedRoles={['super-admin', 'library-admin', 'librarian']} component={SwaggerDoc} />
    ),
    noCollapse: true,
  },
];

export default routes;
